module.exports = __webpack_public_path__ + "img/pic2-0.9f86e759.png";